export default __webpack_public_path__ + "static/sponsor-0caf9075e8ce5911a2ebc47e9c182e4e.png";